import React from "react";
import Text from "shared/ui/typography/Text";

interface FooterProps {
  isMonthNotAvailable: boolean;
  formattedDate: string;
  showLastMonthMessage: boolean;
}

export const DatePickerFooterStandardProduct: React.FC<FooterProps> = ({
  isMonthNotAvailable,
  formattedDate,
  showLastMonthMessage,
}) => {
  return (
    <div className="gg-col-span-12 gg-bg-dark-blue-200 gg-px-6 gg-py-5">
      <Text className={"gg-grid sm:gg-flex"}>
        <span className="gg-mb-0.5 gg-mr-4 gg-font-bold">
          Jouw bezorgafspraak:
        </span>
        <span>{formattedDate}</span>
      </Text>
      {isMonthNotAvailable && (
        <Text className={"gg-grid sm:gg-flex"}>
          <span className="gg-mr-4 gg-font-bold">
            Er zijn geen datums beschikbaar voor deze maand!{" "}
          </span>
        </Text>
      )}

      {showLastMonthMessage && (
        <>
          <Text className="gg-mb-4 gg-mt-4">
            Jij plant ver vooruit, dat is fijn!
          </Text>

          <p className={"gg-relative gg-mb-4"}>
            {
              "Wil je een datum verder in de toekomst vastleggen? Neem dan even contact op met onze klantenservice via "
            }{" "}
            <a
              className={"gg-underline"}
              href="mailto: klantenservice@gewoongers.nl"
            >
              klantenservice@gewoongers.nl
            </a>{" "}
            of{" "}
            <a className={"gg-underline"} href="tel:010 307 28 89">
              010 307 28 89
            </a>
          </p>
        </>
      )}
    </div>
  );
};
